<div class="position-relative">
    <div
        *ngIf="activeTab == transactionCartoccordionTabs.BuyerContactInfo ? createOrEditbuyerContactInfo : createOrEditSellerContactInfo">
        <div class="container-fluid InfoForm thin-scroll">
            <div class="header p-2 my-2 d-flex align-items-center justify-content-between">
                <h6><span class="headertxt"> Company & Contact Information : </span></h6>

            </div>
            <hr class="my-2" />
            <div class="pr-3">
                <div class="row ml-1">
                    <app-contact class="w-100"
                        [isCreateOrEdit]="activeTab == transactionCartoccordionTabs.BuyerContactInfo ? createOrEditbuyerContactInfo : createOrEditSellerContactInfo"
                        [activeTab]="activeTab" [currentTab]="currentTab"
                        [appTransactionsForViewDto]="appTransactionsForViewDto"
                        (updateAppTransactionsForViewDto)="onUpdateAppTransactionsForViewDto($event)"
                        (formValidityChanged)="isContactFormValid($event)"
                        (validateTempBuyer)="validateTempBuyer($event)"
                        (companyId)="getCompanyId($event)"
                        [showDepartment]="activeTab ==transactionCartoccordionTabs.BuyerContactInfo"></app-contact>
                </div>
            </div>
            <hr class="my-2" />
        </div>
        <div *ngIf="!showSaveBtn" class="d-flex justify-content-between mx-4 align-items-center">
            <div>
                <p *ngIf="(appTransactionsForViewDto?.buyerCompanySSIN == '' || appTransactionsForViewDto?.buyerCompanySSIN == null) && activeTab==transactionCartoccordionTabs.BuyerContactInfo"
                    class="p-0 mb-0">*Creating new accounts / contacts will take place upon placing the order</p>

            </div>

            <button [disabled]="!(isContactsValid)" *ngIf="!showSaveBtn " type="button"
                class="continuebtn text-center"  (click)="save(true)">
                Continue
            </button>
        </div>
        <div *ngIf="showSaveBtn" class="d-flex justify-content-end mr-2 pr-3">


            <button *ngIf="showSaveBtn" (click)="cancel()" class="cancelbtn text-center btn ">
                Cancel
            </button>
            <button *ngIf="showSaveBtn" [disabled]="!(isContactsValid)" (click)="save()" type="button"
                class="previewbtn text-center ">
                Save
            </button>

        </div>
    </div>


    <div
        *ngIf="activeTab == transactionCartoccordionTabs.BuyerContactInfo ? !createOrEditbuyerContactInfo : !createOrEditSellerContactInfo">
        <app-view-buyer-seller-contact-info [activeTab]="activeTab" [currentTab]="currentTab"
            [isCreateOrEdit]="activeTab == transactionCartoccordionTabs.BuyerContactInfo ? createOrEditbuyerContactInfo : createOrEditSellerContactInfo"
            [appTransactionsForViewDto]="appTransactionsForViewDto"
            (showBuyer_sellerEditMode)="onshowBuyer_sellerEditMode($event)" (onshowSaveBtn)="onshowSaveBtn($event)"
            [canChange]="canChange" (isContactsValid)="isContactFormValid($event)"></app-view-buyer-seller-contact-info>
    </div>
</div>